import { useEffect } from 'react';

export interface KeyboardShortcutOptions {
  key: string;
  ctrl?: boolean;
  meta?: boolean; // Cmd on Mac, Win on Windows
  alt?: boolean;
  shift?: boolean;
}

export function useKeyboardShortcut(
  options: KeyboardShortcutOptions,
  callback: () => void
) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const { key, ctrl = false, meta = false, alt = false, shift = false } = options;

      const keyMatch = e.key.toLowerCase() === key.toLowerCase();
      const ctrlMatch = ctrl === e.ctrlKey;
      const metaMatch = meta === e.metaKey;
      const altMatch = alt === e.altKey;
      const shiftMatch = shift === e.shiftKey;

      if (keyMatch && ctrlMatch && metaMatch && altMatch && shiftMatch) {
        e.preventDefault();
        callback();
      }
    };

    window.addEventListener('keydown', handler);

    return () => {
      window.removeEventListener('keydown', handler);
    };
  }, [options, callback]);
}

// Cmd+K (Mac) or Ctrl+K (Windows/Linux)
export function useCmdK(callback: () => void) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      // Check for Cmd+K (Mac) or Ctrl+K (Windows/Linux)
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        callback();
      }
    };

    window.addEventListener('keydown', handler);

    return () => {
      window.removeEventListener('keydown', handler);
    };
  }, [callback]);
}
